export enum KnmListFilterActionsEnum {
  KNM_LIST_FILTER_SET_SWITCHER = 'KNM_LIST_FILTER_SET_SWITCHER',
  KNM_LIST_FILTER_SET_CURRENT = 'KNM_LIST_FILTER_SET_CURRENT',
  KNM_LIST_FILTER_SET_PLAN_NUM = 'KNM_LIST_FILTER_SET_PLAN_NUM',
  KNM_LIST_FILTER_GET_META = 'KNM_LIST_FILTER_GET_META',
  KNM_LIST_FILTER_SET_META = 'KNM_LIST_FILTER_SET_META',
  KNM_LIST_FILTER_GET_DATA = 'KNM_LIST_FILTER_GET_DATA',
  KNM_LIST_FILTER_SET_DATA = 'KNM_LIST_FILTER_SET_DATA',
  KNM_LIST_FILTER_CREATE = 'KNM_LIST_FILTER_CREATE',
  KNM_LIST_FILTER_UPDATE = 'KNM_LIST_FILTER_UPDATE',
  KNM_LIST_FILTER_REMOVE = 'KNM_LIST_FILTER_REMOVE',
  KNM_LIST_FILTER_INIT = 'KNM_LIST_FILTER_INIT',
  KNM_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS = 'KNM_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS',
  KNM_LIST_FILTER_SET_CURRENT_FEDERAL_LAWS = 'KNM_LIST_FILTER_SET_CURRENT_FEDERAL_LAWS',
}
